import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="border-t"
      style={{ borderColor: "rgba(255,255,255,0.06)", background: "#050505" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          {/* Brand */}
          <div>
            <h3
              className="text-2xl tracking-wider mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              ELYSIAN{" "}
              <span style={{ color: "#D4AF37" }}>HEIGHTS</span>
            </h3>
            <p
              className="text-sm leading-relaxed"
              style={{ color: "#A3A3A3", fontFamily: "'Manrope', sans-serif" }}
            >
              Coulsdon's most prestigious new development. An address that
              speaks of refinement, legacy, and uncompromising quality.
            </p>
          </div>

          {/* Contact */}
          <div>
            <h4
              className="text-xs tracking-[0.2em] uppercase font-bold mb-6"
              style={{ color: "#D4AF37", fontFamily: "'Manrope', sans-serif" }}
            >
              Contact
            </h4>
            <div className="flex flex-col gap-4">
              <div className="flex items-center gap-3">
                <MapPin size={16} strokeWidth={1} style={{ color: "#D4AF37" }} />
                <span className="text-sm" style={{ color: "#A3A3A3" }}>
                  Coulsdon, Surrey, CR5
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Phone size={16} strokeWidth={1} style={{ color: "#D4AF37" }} />
                <span className="text-sm" style={{ color: "#A3A3A3" }}>
                  07917 303200 / 07956 320321
                </span>
              </div>
              <div className="flex items-center gap-3">
                <Mail size={16} strokeWidth={1} style={{ color: "#D4AF37" }} />
                <span className="text-sm" style={{ color: "#A3A3A3" }}>
                  elysianheightsltd@gmail.com
                </span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-xs tracking-[0.2em] uppercase font-bold mb-6"
              style={{ color: "#D4AF37", fontFamily: "'Manrope', sans-serif" }}
            >
              Quick Links
            </h4>
            <div className="flex flex-col gap-3">
              <a href="/#about" className="text-sm hover:text-white transition-colors" style={{ color: "#A3A3A3" }}>
                About the Development
              </a>
              <a href="/#features" className="text-sm hover:text-white transition-colors" style={{ color: "#A3A3A3" }}>
                Features & Amenities
              </a>
              <Link to="/register" className="text-sm hover:text-white transition-colors" style={{ color: "#A3A3A3" }}>
                Register Your Interest
              </Link>
              <Link to="/admin/login" className="text-sm hover:text-white transition-colors" style={{ color: "#A3A3A3" }}>
                Admin Portal
              </Link>
            </div>
          </div>
        </div>

        <div
          className="mt-16 pt-8 flex flex-col md:flex-row items-center justify-between gap-4"
          style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
        >
          <p className="text-xs" style={{ color: "#666" }}>
            &copy; {new Date().getFullYear()} Elysian Heights. All rights reserved.
          </p>
          <p className="text-xs" style={{ color: "#666" }}>
            A premium development by Elysian Heights Ltd.
          </p>
        </div>
      </div>
    </footer>
  );
};
